// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 1V4H11V1H13ZM20.4853 4.92848L18.364 7.0498L16.9497 5.63559L19.0711 3.51426L20.4853 4.92848ZM4.9289 3.51431L7.05022 5.63563L5.63601 7.04984L3.51469 4.92852L4.9289 3.51431ZM6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 12.8515 17.822 13.664 17.5003 14.4004L17.2383 15H6.76168L6.49969 14.4004C6.17797 13.664 6 12.8515 6 12ZM1 11H4V13H1V11ZM20 11H23V13H20V11ZM2 17H8V19H2V17ZM10 17H22V19H10V17ZM17 21H22V23H17V21ZM2 21H15V23H2V21Z"}}]};

const FogSunnyFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'fog-sunny-filled',
    ref,
    icon: element,
  },
));

FogSunnyFilledIcon.displayName = 'FogSunnyFilledIcon';

export default FogSunnyFilledIcon;
